import type { BspAutoTrackingName } from '$lib/services/tracking/googleAnalytics/events';
import amvLogo from '$assets/logos/amv-logo.webp';
import amvMotoLogo from '$assets/logos/amv-moto-logo.webp';
import { isMobile } from '$lib/services/mediaQuery/screenSize';

const amvMobileCtaId = '6952216047';
const amvDesktopCtaId = '6956008760';

export interface AmvAd {
	trackingName: BspAutoTrackingName;
	title: string;
	ctaText: string;
	ctaUrl: string;
	icon: string;
	pictureLogo: string;
	altPictureLogo: string;
	textLogo: string;
	altTextLogo: string;
};

export const amvAd: AmvAd = {
	trackingName: 'AMV',
	title: 'Êtes-vous sûr de payer le bon prix pour votre Assurance 2-Roues ?',
	ctaText: 'Comparez avec AMV',
	ctaUrl: `http://pubads.g.doubleclick.net/gampad/clk?id=${isMobile ? amvMobileCtaId : amvDesktopCtaId}&iu=/3513/via_int_1_1x1_searchmap`,
	icon: 'open-in-new',
	pictureLogo: amvMotoLogo,
	altPictureLogo: 'AMV',
	textLogo: amvLogo,
	altTextLogo: 'AMV',
};
